const pageNameKey =
  "checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlert";

export const checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertEn =
  {
    [pageNameKey]: {
      duplicateNodesError:
        "An unexpected error has occured: the created structure has duplicate IDs. We deactivated the 'Transfer Configuration to Client' button. Please contact support.",
    },
  };

export const checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertPtBr =
  {
    [pageNameKey]: {
      duplicateNodesError:
        "Ocorreu um erro inesperado: a estrutura criada tem IDs duplicados. Desativamos o botão 'Transfer Configuration to Client'. Entre em contato com o suporte.",
    },
  };

export const checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertDe =
  {
    [pageNameKey]: {
      duplicateNodesError:
        "Ein unerwarteter Fehler ist aufgetreten: Die erstellte Struktur hat doppelte IDs. Wir haben den Button 'Transfer Configuration to Client' deaktiviert. Bitte kontaktieren Sie den Support.",
    },
  };

export const checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertZhHans =
  {
    [pageNameKey]: {
      duplicateNodesError:
        "发生意外错误：创建的结构具有重复的ID。我们已禁用“传输配置到客户端”按钮。请联系支持。",
    },
  };

export const checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertIt =
  {
    [pageNameKey]: {
      duplicateNodesError:
        "Si è verificato un errore imprevisto: la struttura creata contiene ID duplicati. Abbiamo disattivato il pulsante 'Trasferisci configurazione al client'. Contatta il supporto.",
    },
  };

export const checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertEs =
  {
    [pageNameKey]: {
      duplicateNodesError:
        "Se ha producido un error inesperado: la estructura creada tiene ID duplicados. Hemos desactivado el botón 'Transfer Configuration to Client'. Ponte en contacto con el soporte técnico.",
    },
  };

export const checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertNl =
  {
    [pageNameKey]: {
      duplicateNodesError:
        "Er is een onverwachte fout opgetreden: de aangemaakte structuur bevat dubbele ID's. We hebben de knop 'Transfer Configuration to Client' uitgeschakeld. Neem contact op met de ondersteuning.",
    },
  };

export const checkIfStructureHasDuplicatedIdsTriggerErrorSnackBarAndSendSentryAlertTr =
  {
    [pageNameKey]: {
      duplicateNodesError:
        "Beklenmeyen bir hata oluştu: Oluşturulan yapının yinelenen kimlikleri var. 'Yapılandırmayı İstemciye Aktar' butonunu devre dışı bıraktık. Lütfen desteğe başvurun.",
    },
  };
